var shorthandRegex = /^#\w{3}$/;
var replaceInputRegex = /^#(\w)(\w)(\w)$/;
var replaceOutput = '#$1$1$2$2$3$3';
export function toSafeColor(value) {
    if (value && typeof value === 'string') {
        if (value.match(shorthandRegex)) {
            return value.replace(replaceInputRegex, replaceOutput);
        }
        return value;
    }
    return undefined;
}
//# sourceMappingURL=to-safe-color.js.map